import BaseGuideText from "./BaseGuideText";
import { Coord } from "../types/Interface";
import { GUIDE_TEXT_COORD } from "../types/Config";


const text = "Drag the points on the circle";
const color = 0xF82400;


export default class GuideText extends BaseGuideText {
  constructor(coord: Coord = GUIDE_TEXT_COORD) {
    super(text, color, coord);
  }
}